import translate from "../locales";

import { ExercisePage } from "../components/exercise-page";
import { Question } from "../components/form/question";
import { InputGroup } from "../components/form/input-group";
import { TextLabel } from "../components/form/text-label";
import { TextInput } from "../components/form/text-input";

import { useContext } from "react";
import { ClassroomContext } from "../components/classroom.context";
import clsx from "clsx";

export function ExercisePageOthers1({ onPrevious, onNext }) {
  const { requireFields } = useContext(ClassroomContext);

  return (
    <ExercisePage
      title="exercise.others_1.title"
      description="exercise.others_1.description"
      labelPrevious="exercise.others_1.button-previous"
      labelNext="exercise.others_1.button-next"
      showSources
      onPrevious={onPrevious}
      onNext={onNext}
      buttonNextDisabled={
        !requireFields([
          "country_1",
          "support_1",
          "support_how_1",
          "country_2",
          "support_2",
          "support_how_2",
        ])
      }
    >
      <title>{translate("exercise.others_1.page-title")}</title>
      <div className="exercise-card">
        <Question
          question="exercise.others_1.question_1.question"
          description="exercise.others_1.question_1.description"
        >
          <div className={clsx("flex-box", "flex-box_vertical")}>
            <div className={clsx("input-group_background")}>
              <InputGroup>
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.ab-label-before"
                />
                <TextInput
                  id="country_1"
                  placeholder="exercise.others_1.question_1.a-placeholder"
                  maxLength={20}
                />
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.ab-label-between"
                />
                <TextInput
                  id="support_1"
                  placeholder="exercise.others_1.question_1.b-placeholder"
                  maxLength={20}
                />
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.ab-label-after"
                />
              </InputGroup>
              <InputGroup>
                <TextLabel
                  for="support_how_1"
                  label="exercise.others_1.question_1.c-label-before"
                />
                <TextInput
                  id="support_how_1"
                  placeholder="exercise.others_1.question_1.c-placeholder"
                  maxLength={25}
                />
                <TextLabel
                  for="support_how_1"
                  label="exercise.others_1.question_1.c-label-after"
                />
              </InputGroup>
            </div>
            <div className={clsx("input-group_background")}>
              <InputGroup>
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.de-label-before"
                />
                <TextInput
                  id="country_2"
                  placeholder="exercise.others_1.question_1.d-placeholder"
                  maxLength={20}
                />
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.de-label-between"
                />
                <TextInput
                  id="support_2"
                  placeholder="exercise.others_1.question_1.e-placeholder"
                  maxLength={20}
                />
                <TextLabel
                  for=""
                  label="exercise.others_1.question_1.de-label-after"
                />
              </InputGroup>
              <InputGroup>
                <TextLabel
                  for="support_how_2"
                  label="exercise.others_1.question_1.f-label-before"
                />
                <TextInput
                  id="support_how_2"
                  placeholder="exercise.others_1.question_1.f-placeholder"
                  maxLength={25}
                />
                <TextLabel
                  for="support_how_2"
                  label="exercise.others_1.question_1.f-label-after"
                />
              </InputGroup>
            </div>
          </div>
        </Question>
      </div>
    </ExercisePage>
  );
}
